import React from "react";
import { persistor } from "./redux";

const CHUNK_LOAD_PATTERNS = [
  "error loading dynamically imported module",
  "failed to fetch dynamically imported module",
  "importing a module script failed",
  "loading chunk",
  "loading css chunk",
];

const isChunkLoadError = (error) => {
  const msg = (error?.message || "").toLowerCase();
  return CHUNK_LOAD_PATTERNS.some((pattern) => msg.includes(pattern));
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, redirecting: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught an error:", error, info);

    if (isChunkLoadError(error)) {
      this.setState({ redirecting: true });
      // Purge any stale session then redirect to login.
      // persistor.purge() returns a promise; redirect regardless of outcome.
      Promise.resolve(persistor?.purge?.()).finally(() => {
        window.location.replace("/user/login");
      });
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.state.redirecting || isChunkLoadError(this.state.error)) {
        // Redirect is in progress — render nothing
        return null;
      }

      return (
        <div>
          <h2>Something went wrong.</h2>
          <p>{this.state.error?.toString()}</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
